import diia from './diia';
import bankId from './bankId';

export default {
  diia,
  bankId
}
